import { EnumWithDescription, ICustomEnumValue } from "./EnumWithDescription";

export enum PendingReasonEnum {
    None = 0 as any,
    AfterHoursCallRequest = 1 as any,
    AwaitingRelocation = 2 as any,
    CannotContactDecisionMaker = 3 as any,
    Hospitalized = 4 as any,
    LongTermLiveDischarge = 5 as any,
    LongTermAwaitingEligibility = 6 as any,
    NeedDocumentation = 7 as any,
    PatientResidesInNonContactedFacility = 8 as any,
    PatientOrFamilyDecidingOnCareOptions = 10 as any,
    PatientOrFamilyInterviewingHospices = 11 as any,
    PatientOrFamilyRefusingServices = 12 as any,
    PriorityScheduling = 13 as any,
    ScheduledVisit = 14 as any,
    SkilledNursing = 15 as any,
    WaitingOnCallBack = 16 as any,
    Other = 17 as any
}
class PendingReasonClass extends EnumWithDescription<PendingReasonEnum> {
    public readonly enum = PendingReasonEnum;
    public readonly enumName: string = "PendingReasonEnum";

    public readonly enumWithDescriptions: Map<string, ICustomEnumValue<PendingReasonEnum>> = new Map([
        [
            "None",
            {
                value: PendingReasonEnum.None,
                name: "None"
            }
        ],
        [
            "AfterHoursCallRequest",
            {
                value: PendingReasonEnum.AfterHoursCallRequest,
                name: "After-hours call request"
            }
        ],
        [
            "AwaitingRelocation",
            {
                value: PendingReasonEnum.AwaitingRelocation,
                name: "Awaiting relocation"
            }
        ],
        [
            "CannotContactDecisionMaker",
            {
                value: PendingReasonEnum.CannotContactDecisionMaker,
                name: "Cannot contact decision maker"
            }
        ],
        [
            "Hospitalized",
            {
                value: PendingReasonEnum.Hospitalized,
                name: "Hospitalized"
            }
        ],
        [
            "LongTermLiveDischarge",
            {
                value: PendingReasonEnum.LongTermLiveDischarge,
                name: "Long term - live discharge"
            }
        ],
        [
            "LongTermAwaitingEligibility",
            {
                value: PendingReasonEnum.LongTermAwaitingEligibility,
                name: "Long term - awaiting eligibility"
            }
        ],
        [
            "NeedDocumentation",
            {
                value: PendingReasonEnum.NeedDocumentation,
                name: "Need documentation"
            }
        ],
        [
            "PatientResidesInNonContactedFacility",
            {
                value: PendingReasonEnum.PatientResidesInNonContactedFacility,
                name: "Patient resides in non-contacted facility"
            }
        ],
        [
            "PatientOrFamilyDecidingOnCareOptions",
            {
                value: PendingReasonEnum.PatientOrFamilyDecidingOnCareOptions,
                name: "Patient/family - deciding on care options"
            }
        ],
        [
            "PatientOrFamilyInterviewingHospices",
            {
                value: PendingReasonEnum.PatientOrFamilyInterviewingHospices,
                name: "Patient/family - interviewing hospices"
            }
        ],
        [
            "PatientOrFamilyRefusingServices",
            {
                value: PendingReasonEnum.PatientOrFamilyRefusingServices,
                name: "Patient/family - refusing services"
            }
        ],
        [
            "PriorityScheduling",
            {
                value: PendingReasonEnum.PriorityScheduling,
                name: "Priority scheduling"
            }
        ],
        [
            "ScheduledVisit",
            {
                value: PendingReasonEnum.ScheduledVisit,
                name: "Scheduled visit"
            }
        ],
        [
            "SkilledNursing",
            {
                value: PendingReasonEnum.SkilledNursing,
                name: "Skilled nursing"
            }
        ],
        [
            "WaitingOnCallBack",
            {
                value: PendingReasonEnum.WaitingOnCallBack,
                name: "Waiting on call back"
            }
        ],
        [
            "Other",
            {
                value: PendingReasonEnum.Other,
                name: "Other"
            }
        ]
    ]);
}

export const PendingReason = new PendingReasonClass();
